import { debounce } from 'lodash'
import { useCallback, useEffect, useState } from 'react'
// import Select from 'react-select';
import 'bootstrap-daterangepicker/daterangepicker.css'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'
import { Alert, Spinner } from 'react-bootstrap'
import { FaEye } from 'react-icons/fa6'
import Lightbox from 'react-image-lightbox'
import Select, { components } from 'react-select'
import { toast } from 'react-toastify'
import { Tooltip } from 'react-tooltip'
import { KTSVG } from '../../../_metronic/helpers'
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp'
import DateComp from '../../../components/dateComponent/DateComp'
import DateRangeComp from '../../../components/dateComponent/DateRangeComp'
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent'
import NoRecordFound from '../../../components/noRecord/NoRecordFound'
import Pagination from '../../../components/pagination/Pagination'
import RefreshComponent from '../../../components/refreshComponent/RefreshComponent'
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent'
import ExpenseStatusComp from '../../../components/StatusComp/ExpenseStatusComp'
import TableHeading from '../../../components/tableHeading/TableHeading'
import TableSettingMenu from '../../../components/tableHeading/TableSettingMenu'
import SearchSelect from '../../../components/textFields/SearchSelect'
import TextField from '../../../components/textFields/TextField'
import DateField from '../../../components/textFields/DateField'
import { constraintConfig } from '../../../constraintConfig'
import { useLazyGetExpenseItemsByExpenseItemIdQuery } from '../../../services/ExpenseApi'
import {
  useExpenseStatusLookupQuery,
  useGetAllCategoryQuery,
  useGetAllUsersManagerAdminQuery,
  useGetPaymentMethodLookupQuery,
} from '../../../services/GeneralApi'
import {
  useExpenseItemsViewReportExportQuery,
  useLazyExpenseItemsViewtExcelExportReportQuery,
} from '../../../services/ReportAndAnalyticsApi'
import useColumnVisibility from '../../customHooks/useColumnVisibility'
import labelKey from '../../localization/label.json'
import tosterKey from '../../localization/toster.json'
import SingleItemDetailModal from '../expenseItems/update-single-Item/SingleItemDetailModal'
import ReactReadMoreReadLess from "react-read-more-read-less";


interface LightboxData {
  imageURL: string
}
const { Option } = components
type Option = {
  value: string
  label: string
}

// Custom Option component to add checkboxes
const CheckboxOption = (props: any) => {
  return (
    <Option {...props} className='d-flex align-items-start gap-2'>
      <input type='checkbox' checked={props.isSelected} onChange={() => null} />{' '}
      <label>{props.label}</label>
    </Option>
  )
}

const ExportExpenseReports = () => {
  const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'exportReports' })
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [lightboxData, setLightboxData] = useState<LightboxData>({ imageURL: '' })
  const currentDate = moment().format('MM/DD/YYYY')
  const sevenDaysAgo = moment().subtract(6, 'days').format('MM/DD/YYYY')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [searchStr, setSearchStr] = useState('') // debounce search
  const [immediateSearchStr, setImmediateSearchStr] = useState('')
  const [sortBy, setSortBy] = useState('createdDate')
  const [sortOrder, setSortOrder] = useState('desc')
  const [filterByStartDate, setFilterByStartDate] = useState(sevenDaysAgo)
  const [filterByEndDate, setFilterByEndDate] = useState(currentDate)
  const [sortedColumn, setSortedColumn] = useState('createdDate')
  const [localFilterByStartDate, setLocalFilterByStartDate] = useState(sevenDaysAgo)
  const [localFilterByEndDate, setLocalFilterByEndDate] = useState(currentDate)
  const [filterByUserIds, setFilterByUserIds] = useState<string[]>([])
  const [localFilterByUserIds, setLocalFilterByUserIds] = useState<string[]>([])

  const [selectedUserIds, setSelectedUserIds] = useState<Option[]>([])
  const [filterByStatus, setFilterByStatus] = useState('')
  const [filterByPaymentMethod, setFilterByPaymentMethod] = useState('')
  const [filterByCategories, setFilterByCategories] = useState('')
  const [localFilterByReportId, setLocalFilterByReportId] = useState('')
  const [filterByReportId, setFilterByReportId] = useState('')

  const [localFilterByStatus, setLocalFilterByStatus] = useState('')
  const [localFilterByPaymentMethod, setLocalFilterByPaymentMethod] = useState('')
  const [localFilterByCategories, setLocalFilterByCategories] = useState('')
  const [isApplyingFilters, setIsApplyingFilters] = useState(false)

  // Report Date filter states
  const [filterByReportDate, setFilterByReportDate] = useState<Date | null>(null)
  const [localFilterByReportDate, setLocalFilterByReportDate] = useState<Date | null>(null)

  // BC Sync Date range states (default null)
  const [bcSyncStartDate, setBcSyncStartDate] = useState<string | null>(null)
  const [bcSyncEndDate, setBcSyncEndDate] = useState<string | null>(null)
  const [localBcSyncStartDate, setLocalBcSyncStartDate] = useState<string | null>(null)
  const [localBcSyncEndDate, setLocalBcSyncEndDate] = useState<string | null>(null)

  const { data: getUserByManager } = useGetAllUsersManagerAdminQuery('')
  const { data: getAllExpenseStatus } = useExpenseStatusLookupQuery('')
  const { data: getAllPaymentMethod } = useGetPaymentMethodLookupQuery('')
  const { data: categoriesData } = useGetAllCategoryQuery('')

  const {
    data,
    isFetching: isLoading,
    refetch,
    isSuccess,
  } = useExpenseItemsViewReportExportQuery({
    pageNumber: page,
    pageSize: pageSize,
    sortBy: sortBy,
    sortOrder: sortOrder,
    searchStr: searchStr,
    startDate: filterByStartDate,
    endDate: filterByEndDate,
    reportDate: filterByReportDate ? moment(filterByReportDate).format('MM/DD/YYYY') : '',
    bcSyncStartDate: bcSyncStartDate || '',
    bcSyncEndDate: bcSyncEndDate || '',
    userIds: filterByUserIds.length > 0 ? filterByUserIds : null,
    reportStatusId: filterByStatus,
    paymentMethodIds: filterByPaymentMethod,
    expenseCategoryId: filterByCategories,
    reportId: filterByReportId,
  })
  const [expenseItemByIdTrigger, { data: expenseItemData, isFetching }] =
    useLazyGetExpenseItemsByExpenseItemIdQuery({})
  const [excelReportTrigger, { data: excelReportData, isFetching: excelReportIsFecting }] =
    useLazyExpenseItemsViewtExcelExportReportQuery({})
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async () => {
    setDownloading(true)
    try {
      const blob = await excelReportTrigger({
        startDate: filterByStartDate,
        endDate: filterByEndDate,
        reportDate: filterByReportDate ? moment(filterByReportDate).format('MM/DD/YYYY') : '',
        bcSyncStartDate: bcSyncStartDate || '',
        bcSyncEndDate: bcSyncEndDate || '',
        userIds: filterByUserIds.length > 0 ? filterByUserIds : null,
        reportStatusId: filterByStatus,
        paymentMethodIds: filterByPaymentMethod,
        expenseCategoryId: filterByCategories,
        reportId: filterByReportId,
      }).unwrap()

      if (blob) {
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'Expense_Report.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      console.error('Download failed:', error)
    } finally {
      setDownloading(false)
    }
  }

  const handlePageSizeChange = (e: any) => {
    const newSize = parseInt(e.target.value)
    setPageSize(newSize)
    setPage(1)
  }

  const handlePageClick = (e: { selected: number }) => {
    setPage(e.selected + 1)
  }

  const handleSort = (property: string) => {
    setSortBy(property)
    if (sortedColumn === property) {
      setSortOrder((prevSortOrder) => (prevSortOrder === 'asc' ? 'desc' : 'asc'))
    } else {
      setSortedColumn(property)
      setSortOrder('asc')
    }
  }

  const handlePageRecords = (e: any) => {
    setPage(1)
  }

  const handleSearchChange = (e: any) => {
    const { value } = e.target
    setImmediateSearchStr(value)
    delayedSearch(value)
    setPage(1)
  }

  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue)
    }, 500),
    []
  )

  // Item Date Range handlers
  const handleDateRangeChange = (event: any, picker: any) => {
    const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY')
    const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY')
    setLocalFilterByStartDate(startDateFormatted)
    setLocalFilterByEndDate(endDateFormatted)
  }

  const handleCancelDateSelection = (event: any, picker: any) => {
    setFilterByStartDate('')
    setFilterByEndDate('')
    setLocalFilterByStartDate('')
    setLocalFilterByEndDate('')
  }

  // BC Sync Date Range handlers
  const handleBcSyncDateRangeChange = (event: any, picker: any) => {
    const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY')
    const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY')
    setLocalBcSyncStartDate(startDateFormatted)
    setLocalBcSyncEndDate(endDateFormatted)
  }

  const handleCancelBcSyncDateSelection = () => {
    setLocalBcSyncStartDate(null)
    setLocalBcSyncEndDate(null)
  }

  const userIdsOptions: Option[] = getUserByManager?.result?.map((userByManager: any) => ({
    value: userByManager.id,
    label: userByManager.value,
  }))

  const handleUserIdsChange = (selected: Option[]) => {
    setSelectedUserIds(selected)
    setLocalFilterByUserIds(selected?.map((userByManager) => userByManager.value))
  }

  const handleFilterByStatus = (selectedOption: any) => {
    setLocalFilterByStatus(selectedOption.value)
  }
  const handleFilterByPaymentMethod = (selectedOption: any) => {
    setLocalFilterByPaymentMethod(selectedOption.value)
  }
  const handleFilterByCategories = (selectedOption: any) => {
    setLocalFilterByCategories(selectedOption.value)
  }
  const handleChangeReportId = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    if (/^[0-9-]*$/.test(value)) {
      setLocalFilterByReportId(value)
    }
  }

  const applyFilters = () => {
    setIsApplyingFilters(true)
    setFilterByStartDate(localFilterByStartDate)
    setFilterByEndDate(localFilterByEndDate)
    setFilterByUserIds(localFilterByUserIds)
    setFilterByStatus(localFilterByStatus)
    setFilterByPaymentMethod(localFilterByPaymentMethod)
    setFilterByCategories(localFilterByCategories)
    setFilterByReportId(localFilterByReportId)
    setFilterByReportDate(localFilterByReportDate)
    setBcSyncStartDate(localBcSyncStartDate)
    setBcSyncEndDate(localBcSyncEndDate)
    setPage(1)
  }

  const resetFilters = () => {
    setFilterByStartDate(sevenDaysAgo)
    setFilterByEndDate(currentDate)
    setFilterByUserIds([])
    setFilterByStatus('')
    setFilterByPaymentMethod('')
    setFilterByCategories('')

    setLocalFilterByStartDate(sevenDaysAgo)
    setLocalFilterByEndDate(currentDate)
    setLocalFilterByUserIds([])
    setLocalFilterByStatus('')
    setLocalFilterByPaymentMethod('')
    setLocalFilterByCategories('')
    setFilterByReportId('')
    setLocalFilterByReportId('')
    setFilterByReportDate(null)
    setLocalFilterByReportDate(null)

    // Reset BC Sync Date range to null
    setBcSyncStartDate(null)
    setBcSyncEndDate(null)
    setLocalBcSyncStartDate(null)
    setLocalBcSyncEndDate(null)

    setSelectedUserIds([])
  }

  const debouncedRefetch = debounce(() => {
    refetch().finally(() => {
      setIsApplyingFilters(false)
    })
  }, 300)

  useEffect(() => {
    if (isApplyingFilters) {
      debouncedRefetch()
    }
  }, [isApplyingFilters])

  useEffect(() => {
    if (searchStr === '' || sortOrder === '' || sortBy === '') {
      refetch()
    }
  }, [searchStr, sortOrder, sortBy])

  const exportExpenseSummaryReport = async () => {
    if (data?.result?.data) {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Export Expense Report')
      worksheet.columns = [
        { header: 'Item Date', key: 'itemTransactionDate', width: 20 },
        { header: 'Report Date', key: 'reportDate', width: 20 },
        { header: 'BC Sync Date', key: 'syncSSToBCDateTime', width: 25 },
        { header: 'Report ID', key: 'sS_ReportNo', width: 15 },
        { header: 'Report Title', key: 'reportTitle', width: 15 },
        { header: 'User', key: 'submitted_By', width: 20 },
        { header: 'Amount', key: 'amount', width: 15 },
        { header: 'Payment Method', key: 'paymentMethod', width: 15 },
        { header: 'Report Status', key: 'reportStatus', width: 15 },
        { header: 'Assigned To', key: 'assignedToName', width: 30 },
        { header: 'Receipt URL', key: 'receipt', width: 20 },
      ].filter(Boolean)
      worksheet.getRow(1).font = { bold: true }
      data?.result?.data.forEach((data: any) => {
        worksheet.addRow({
          itemTransactionDate: data?.itemTransactionDate,
          reportDate: data?.reportDate,
          syncSSToBCDateTime: data?.syncSSToBCDateTime,
          sS_ReportNo: data?.sS_ReportNo,
          reportTitle: data?.reportTitle,
          submitted_By: data?.submitted_By,
          amount: data?.amount,
          paymentMethod: data?.paymentMethod,
          reportStatus: formatStatus(data?.expenseStatusId),
          assignedToName: data?.assignedToName,
          receipt: data?.receipt,
        })
      })
      const buffer = await workbook.xlsx.writeBuffer()
      saveAs(new Blob([buffer]), `ExportReport_${Date.now()}.xlsx`)
    }
  }

  const exportExpenseTransactionDetail = async () => {
    if (data?.result?.data) {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Export Expense Report')
      worksheet.columns = [
        { header: 'Item Date', key: 'itemTransactionDate', width: 20 },
        { header: 'Report Date', key: 'reportDate', width: 20 },
        { header: 'BC Sync Date', key: 'syncSSToBCDateTime', width: 25 },
        { header: 'Report ID', key: 'sS_ReportNo', width: 15 },
        { header: 'Report Title', key: 'reportTitle', width: 15 },
        { header: 'User', key: 'submitted_By', width: 20 },
        { header: 'Amount', key: 'amount', width: 15 },
        { header: 'Category', key: 'categoryName', width: 20 },
        { header: 'Payment Method', key: 'paymentMethod', width: 15 },
        { header: 'Report Status', key: 'reportStatus', width: 15 },
        { header: 'Department Code', key: 'chargeDepartmentCode', width: 20 },
        { header: 'Department Name', key: 'chargeDepartmentName', width: 25 },
        { header: 'Split ToLocations', key: 'splitToLocationsName', width: 50 },
        { header: 'Charge Location Code', key: 'chargeLocationCode', width: 20 },
        { header: 'Charge Location Name', key: 'chargeLocationName', width: 25 },
        { header: 'Assigned To', key: 'assignedToName', width: 30 },
        { header: 'Receipt URL', key: 'receipt', width: 20 },
        { header: 'Report Submitted Date', key: 'reportSubmittedDate', width: 25 },
        { header: 'AP Approved Date', key: 'apApprovedDate', width: 20 },
        { header: 'Paid Date', key: 'paidDate', width: 20 },
        { header: 'Source', key: 'transactionSource', width: 20 },
      ].filter(Boolean)
      worksheet.getRow(1).font = { bold: true }
      data?.result?.data.forEach((data: any) => {
        worksheet.addRow({
          itemTransactionDate: data?.itemTransactionDate,
          reportDate: data?.reportDate,
          syncSSToBCDateTime: data?.syncSSToBCDateTime,
          sS_ReportNo: data?.sS_ReportNo,
          reportTitle: data?.reportTitle,
          submitted_By: data?.submitted_By,
          amount: data?.amount,
          categoryName: data?.categoryName,
          paymentMethod: data?.paymentMethod,
          reportStatus: formatStatus(data?.expenseStatusId),
          chargeDepartmentCode: data?.chargeDepartmentCode,
          chargeDepartmentName: data?.chargeDepartmentName,
          splitToLocationsName: data?.splitToLocationsName,
          chargeLocationCode: data?.chargeLocationCode,
          chargeLocationName: data?.chargeLocationName,
          assignedToName: data?.assignedToName,
          receipt: data?.receipt,
          reportSubmittedDate: data?.reportSubmittedDate,
          apApprovedDate: data?.apApprovedDate,
          paidDate: data?.paidDate,
          transactionSource: data?.transactionSource,
        })
      })
      const buffer = await workbook.xlsx.writeBuffer()
      saveAs(new Blob([buffer]), `EXPENSE TRANSACTION DETAIL.xlsx`)
    }
  }

  const formatStatus = (statusId: number) => {
    switch (statusId) {
      case constraintConfig.expenseStatus.drafted:
        return labelKey.draft
      case constraintConfig.expenseStatus.pendingForApproval:
        return labelKey.pendingForApproval
      case constraintConfig.expenseStatus.approved:
        return labelKey.managerApproved
      case constraintConfig.expenseStatus.rejected:
        return labelKey.rejected
      case constraintConfig.expenseStatus.apApproved:
        return labelKey.aPApproved
      case constraintConfig.expenseStatus.processing:
        return labelKey.processing
      case constraintConfig.expenseStatus.paid:
        return labelKey.paid
      case constraintConfig.expenseStatus.pendingForAP:
        return labelKey.pendingForAPApproval
      case constraintConfig.expenseStatus.RejectedAPReview:
        return labelKey.rejectedAPReview
      default:
        return ''
    }
  }

  const handleRefresh = () => {
    setTimeout(() => {
      refetch().then(() => {
        if (isSuccess) {
          toast.success(tosterKey.dataRefreshedSuccesfully)
        }
      })
    }, 0)
  }

  const isPdfFile = (filePath: string | undefined) => {
    if (!filePath) return false
    const fileExtension = filePath.toLowerCase().split('.').pop()
    return fileExtension === 'pdf'
  }

  const openPdfInBrowserOrLightbox = (attachmentFile: string | undefined) => {
    if (attachmentFile) {
      if (isPdfFile(attachmentFile)) {
        window.open(attachmentFile, '_blank')
      } else {
        setLightboxData({ imageURL: attachmentFile })
        setLightboxOpen(true)
      }
    }
  }

  const [showUpdateExpenseItemModal, setShowUpdateExpenseItemModal] = useState(false)
  const expenseItemModalHandler = () => {
    setShowUpdateExpenseItemModal((prev) => !prev)
  }

  return (
    <>
      {lightboxOpen && (
        <Lightbox
          mainSrc={lightboxData.imageURL}
          onCloseRequest={() => setLightboxOpen(false)}
          imageCaption='Attachment'
          enableZoom={true}
          imagePadding={50}
        />
      )}
      <SingleItemDetailModal
        show={showUpdateExpenseItemModal}
        handleClose={() => setShowUpdateExpenseItemModal(false)}
        data={expenseItemData?.result}
        viewOnlyData={true}
      />
      <div className='card' style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
        <div className='card-header border-0 align-items-center'>
          <Alert variant='primary' className='w-100 py-2 mt-2'>
            <p className='mb-0 fs-6 pt-1'>
              You can export an Excel file based on the applied filters, with the default date range
              set to the last 7 days.
            </p>
          </Alert>
          <div className='d-flex align-items-center gap-2'>
            <SearchBarComponent
              placeholder='Expense'
              value={immediateSearchStr}
              onChange={handleSearchChange}
            />
            <RefreshComponent onClick={handleRefresh} />
          </div>

          <div className='d-flex gap-2 align-items-center ms-auto'>
            <button
              type='button'
              className='btn btn-sm btn-light-primary me-3 d-flex justify-content-end'
              role='button'
              data-bs-toggle='collapse'
              data-bs-target='#report_filters'
              aria-expanded='true'
              aria-controls='report_filters'
            >
              <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
              {labelKey.filter}
            </button>
            <button
              type='button'
              className='btn btn-sm btn-info'
              disabled={downloading || excelReportIsFecting}
              onClick={handleDownload}
            >
              <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
              {downloading || excelReportIsFecting
                ? 'Exporting Expense Summary Report'
                : 'Export Expense Summary Report'}
            </button>
          </div>
        </div>
        <div className='card-body pb-5 pt-0'>
          <div
            className='row mt-3 border-0 align-items-end collapse border-bottom'
            id='report_filters'
          >
            <div className='col-md-4 col-lg-3 col-xl-2 mb-5' style={{ zIndex: 10 }}>
              <DateRangeComp
                startDate={localFilterByStartDate || moment().subtract(6, 'days')}
                endDate={localFilterByEndDate || moment()}
                label='Item Date Range'
                onApply={handleDateRangeChange}
                onCancel={handleCancelDateSelection}
                value={
                  localFilterByStartDate && localFilterByEndDate
                    ? `${localFilterByStartDate} - ${localFilterByEndDate}`
                    : 'MM/DD/YYYY'
                }
              />
            </div>
            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
              <label className='form-label fs-6 fw-bold'>{labelKey.users}:</label>
              <Select
                isMulti
                options={userIdsOptions}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                onChange={(selected) => handleUserIdsChange(selected as Option[])}
                value={selectedUserIds}
                placeholder='Search User...'
                className='filter-valueContainer'
              />
            </div>
            <div className='col-md-4 col-lg-3 col-xl-2 mb-4'>
              <label className='form-label fs-6 fw-bold'>Report Status:</label>
              <Select
                isMulti
                options={
                  Array.isArray(getAllExpenseStatus?.result)
                    ? getAllExpenseStatus.result
                      .filter((option: any) => option.id !== 6)
                      .map((option: any) => ({
                        value: option.id,
                        label: option.value,
                      }))
                    : []
                }
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                onChange={(selected: any) => {
                  if (!selected || selected.length === 0) {
                    setLocalFilterByStatus('')
                  } else {
                    setLocalFilterByStatus(selected.map((opt: any) => opt.value))
                  }
                }}
                value={
                  Array.isArray(localFilterByStatus) && localFilterByStatus.length > 0
                    ? localFilterByStatus
                      .map((id: number) => {
                        const option = getAllExpenseStatus?.result.find((o: any) => o.id === id)
                        return option ? { value: option.id, label: option.value } : null
                      })
                      .filter(Boolean)
                    : []
                }
                placeholder='Select Status...'
                className='filter-valueContainer'
              />
            </div>

            <div className='col-md-4 col-lg-3 col-xl-2 mb-4'>
              <label className='form-label fs-6 fw-bold'>{labelKey.paymentMethod}:</label>
              <Select
                isMulti
                options={
                  Array.isArray(getAllPaymentMethod?.result)
                    ? getAllPaymentMethod.result.map((option: any) => ({
                      value: option.id,
                      label: option.value,
                    }))
                    : []
                }
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                onChange={(selected: any) => {
                  if (!selected || selected.length === 0) {
                    setLocalFilterByPaymentMethod('')
                  } else {
                    setLocalFilterByPaymentMethod(selected.map((opt: any) => opt.value))
                  }
                }}
                value={
                  Array.isArray(localFilterByPaymentMethod) && localFilterByPaymentMethod.length > 0
                    ? localFilterByPaymentMethod
                      .map((id: number) => {
                        const option = getAllPaymentMethod?.result.find((o: any) => o.id === id)
                        return option ? { value: option.id, label: option.value } : null
                      })
                      .filter(Boolean)
                    : []
                }
                placeholder='Select Payment Method...'
                className='filter-valueContainer'
              />
            </div>

            <div className='col-md-4 col-lg-3 col-xl-2 mb-4'>
              <label className='form-label fs-6 fw-bold'>{labelKey.categories}:</label>
              <Select
                isMulti
                options={
                  Array.isArray(categoriesData?.result)
                    ? categoriesData.result
                      .filter((option: any) => option.categoryId !== 1)
                      .map((option: any) => ({
                        value: option.categoryId,
                        label: option.title,
                      }))
                    : []
                }
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                onChange={(selected: any) => {
                  if (!selected || selected.length === 0) {
                    setLocalFilterByCategories('')
                  } else {
                    setLocalFilterByCategories(selected.map((opt: any) => opt.value))
                  }
                }}
                value={
                  Array.isArray(localFilterByCategories) && localFilterByCategories.length > 0
                    ? localFilterByCategories
                      .map((id: number) => {
                        const option = categoriesData?.result.find(
                          (o: any) => o.categoryId === id
                        )
                        return option ? { value: option.categoryId, label: option.title } : null
                      })
                      .filter(Boolean)
                    : []
                }
                placeholder='Select Category...'
                className='filter-valueContainer'
              />
            </div>

            <div className='col-md-4 col-lg-3 col-xl-2 mb-5' style={{ zIndex: 10 }}>
              <DateField
                label={labelKey.reportDate}
                selected={localFilterByReportDate}
                onChange={(date) => setLocalFilterByReportDate(date)}
              />
            </div>

            {/* BC Sync Date Range Picker - exactly like Item Date Range */}
            <div className='col-md-4 col-lg-3 col-xl-2 mb-5' style={{ zIndex: 10 }}>
              <DateRangeComp
                startDate={localBcSyncStartDate || moment()}
                endDate={localBcSyncEndDate || moment()}
                label={labelKey.bcSyncDate}
                onApply={handleBcSyncDateRangeChange}
                onCancel={handleCancelBcSyncDateSelection}
                value={
                  localBcSyncStartDate && localBcSyncEndDate
                    ? `${localBcSyncStartDate} - ${localBcSyncEndDate}`
                    : 'MM/DD/YYYY'
                }
              />
            </div>

            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
              <TextField
                label={labelKey.reportId}
                type='text'
                onChange={handleChangeReportId}
                value={localFilterByReportId}
                placeholder='Enter Report ID'
              />
            </div>

            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
              <div className='d-flex align-items-end h-100 gap-3'>
                <button className='btn btn-danger pull-right me-3' onClick={resetFilters}>
                  Reset Filters
                </button>
                <button className='btn btn-primary pull-right' onClick={applyFilters}>
                  {isApplyingFilters ? (
                    <>
                      <span>loading...</span>
                      <Spinner
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                      />
                    </>
                  ) : (
                    'Apply Filters'
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <div className='table-responsive table-height'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      {hiddenColumns.includes('itemTransactionDate') && (
                        <TableHeading
                          label={labelKey.itemDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='itemTransactionDate'
                          className='ps-4'
                        />
                      )}
                      {hiddenColumns.includes('reportDate') && (
                        <TableHeading
                          label={labelKey.reportDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='reportDate'
                        />
                      )}
                      {hiddenColumns.includes('syncSSToBCDateTime') && (
                        <TableHeading
                          label={labelKey.bcSyncDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='syncSSToBCDateTime'
                        />
                      )}
                      {hiddenColumns.includes('sS_ReportNo') && (
                        <TableHeading
                          label={labelKey.reportId}
                          columnId='sS_ReportNo'
                          className='ps-4'
                        />
                      )}
                      {hiddenColumns.includes('reportTitle') && (
                        <TableHeading
                          label={labelKey.reportTitle}
                          columnId='reportTitle'
                          className='ps-4'
                        />
                      )}
                      {hiddenColumns.includes('manager') && (
                        <TableHeading
                          label={labelKey.manager}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='manager'
                        />
                      )}
                      {hiddenColumns.includes('submitted_By') && (
                        <TableHeading
                          label={labelKey.user}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='submitted_By'
                        />
                      )}
                      {hiddenColumns.includes('amount') && (
                        <TableHeading
                          label={labelKey.totalAmount}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='amount'
                        />
                      )}
                      {hiddenColumns.includes('categoryName') && (
                        <TableHeading
                          label={labelKey.category}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='categoryName'
                        />
                      )}
                      {hiddenColumns.includes('vendorName') && (
                        <TableHeading
                          label={labelKey.vendor}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='vendorName'
                        />
                      )}
                      {hiddenColumns.includes('expenseDetail') && (
                        <TableHeading
                          label={labelKey.itemDescription}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='expenseDetail'
                        />
                      )}
                      {hiddenColumns.includes('merchantType') && (
                        <TableHeading
                          label={labelKey.merchantType}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='merchantType'
                        />
                      )}
                      {hiddenColumns.includes('paymentMethod') && (
                        <TableHeading
                          label={labelKey.paymentMethod}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='paymentMethod'
                        />
                      )}
                      {hiddenColumns.includes('reportStatus') && (
                        <TableHeading
                          label={labelKey.reportStatus}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='reportStatus'
                        />
                      )}
                      {hiddenColumns.includes('assignedToName') && (
                        <TableHeading
                          label={labelKey.assignTo}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='assignedToName'
                        />
                      )}
                      {hiddenColumns.includes('receipt') && (
                        <TableHeading
                          label={labelKey.receipt}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='receipt'
                        />
                      )}
                      {hiddenColumns.includes('chargeDepartmentCode') && (
                        <TableHeading
                          label={labelKey.departmentCode}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='chargeDepartmentCode'
                        />
                      )}
                      {hiddenColumns.includes('chargeDepartmentName') && (
                        <TableHeading
                          label={labelKey.department}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='chargeDepartmentName'
                        />
                      )}
                      {hiddenColumns.includes('splitToLocationsName') && (
                        <TableHeading
                          label={labelKey.splitToLocations}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='splitToLocationsName'
                        />
                      )}
                      {hiddenColumns.includes('chargeLocationCode') && (
                        <TableHeading
                          label={labelKey.locationCode}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='chargeLocationCode'
                        />
                      )}
                      {hiddenColumns.includes('chargeLocationName') && (
                        <TableHeading
                          label={labelKey.locationName}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='chargeLocationName'
                        />
                      )}
                      {hiddenColumns.includes('expenseLineItemNo') && (
                        <TableHeading
                          label={labelKey.ExpenseItemNo}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='expenseLineItemNo'
                        />
                      )}
                      {hiddenColumns.includes('reportSubmittedDate') && (
                        <TableHeading
                          label={labelKey.reportSubmittedDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='reportSubmittedDate'
                        />
                      )}
                      {hiddenColumns.includes('apApprovedDate') && (
                        <TableHeading
                          label={labelKey.apApprovedDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='apApprovedDate'
                        />
                      )}
                      {hiddenColumns.includes('paidDate') && (
                        <TableHeading
                          label={labelKey.paidDate}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='paidDate'
                        />
                      )}
                      {hiddenColumns.includes('createdBy') && (
                        <TableHeading
                          label={'Created by'}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='createdBy'
                        />
                      )}
                      {hiddenColumns.includes('userStatus') && (
                        <TableHeading
                          label={'User Status'}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='userStatus'
                        />
                      )}
                      {hiddenColumns.includes('transactionSource') && (
                        <TableHeading
                          label={labelKey.source}
                          sortedColumn={sortedColumn}
                          sortOrder={sortOrder}
                          handleSort={handleSort}
                          columnId='transactionSource'
                        />
                      )}
                      <th className='text-end rounded-end pe-2 border-0'>
                        <TableSettingMenu>
                          <TextField
                            rightLabel={labelKey.itemDate}
                            type='checkbox'
                            onChange={() => handleToggleColumn('itemTransactionDate')}
                            checked={hiddenColumns.includes('itemTransactionDate')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.reportDate}
                            type='checkbox'
                            onChange={() => handleToggleColumn('reportDate')}
                            checked={hiddenColumns.includes('reportDate')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.bcSyncDate}
                            type='checkbox'
                            onChange={() => handleToggleColumn('syncSSToBCDateTime')}
                            checked={hiddenColumns.includes('syncSSToBCDateTime')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.reportId}
                            type='checkbox'
                            onChange={() => handleToggleColumn('sS_ReportNo')}
                            checked={hiddenColumns.includes('sS_ReportNo')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.reportTitle}
                            type='checkbox'
                            onChange={() => handleToggleColumn('reportTitle')}
                            checked={hiddenColumns.includes('reportTitle')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.manager}
                            type='checkbox'
                            onChange={() => handleToggleColumn('manager')}
                            checked={hiddenColumns.includes('manager')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.user}
                            type='checkbox'
                            onChange={() => handleToggleColumn('submitted_By')}
                            checked={hiddenColumns.includes('submitted_By')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.totalAmount}
                            type='checkbox'
                            onChange={() => handleToggleColumn('amount')}
                            checked={hiddenColumns.includes('amount')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.category}
                            type='checkbox'
                            onChange={() => handleToggleColumn('categoryName')}
                            checked={hiddenColumns.includes('categoryName')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.vendor}
                            type='checkbox'
                            onChange={() => handleToggleColumn('vendorName')}
                            checked={hiddenColumns.includes('vendorName')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.itemDescription}
                            type='checkbox'
                            onChange={() => handleToggleColumn('expenseDetail')}
                            checked={hiddenColumns.includes('expenseDetail')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.merchantType}
                            type='checkbox'
                            onChange={() => handleToggleColumn('merchantType')}
                            checked={hiddenColumns.includes('merchantType')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.paymentMethod}
                            type='checkbox'
                            onChange={() => handleToggleColumn('paymentMethod')}
                            checked={hiddenColumns.includes('paymentMethod')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.reportStatus}
                            type='checkbox'
                            onChange={() => handleToggleColumn('reportStatus')}
                            checked={hiddenColumns.includes('reportStatus')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.assignTo}
                            type='checkbox'
                            onChange={() => handleToggleColumn('assignedToName')}
                            checked={hiddenColumns.includes('assignedToName')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.receipt}
                            type='checkbox'
                            onChange={() => handleToggleColumn('receipt')}
                            checked={hiddenColumns.includes('receipt')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.departmentCode}
                            type='checkbox'
                            onChange={() => handleToggleColumn('chargeDepartmentCode')}
                            checked={hiddenColumns.includes('chargeDepartmentCode')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.department}
                            type='checkbox'
                            onChange={() => handleToggleColumn('chargeDepartmentName')}
                            checked={hiddenColumns.includes('chargeDepartmentName')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.splitToLocations}
                            type='checkbox'
                            onChange={() => handleToggleColumn('splitToLocationsName')}
                            checked={hiddenColumns.includes('splitToLocationsName')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.locationCode}
                            type='checkbox'
                            onChange={() => handleToggleColumn('chargeLocationCode')}
                            checked={hiddenColumns.includes('chargeLocationCode')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.locationName}
                            type='checkbox'
                            onChange={() => handleToggleColumn('chargeLocationName')}
                            checked={hiddenColumns.includes('chargeLocationName')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.ExpenseItemNo}
                            type='checkbox'
                            onChange={() => handleToggleColumn('expenseLineItemNo')}
                            checked={hiddenColumns.includes('expenseLineItemNo')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.reportSubmittedDate}
                            type='checkbox'
                            onChange={() => handleToggleColumn('reportSubmittedDate')}
                            checked={hiddenColumns.includes('reportSubmittedDate')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.apApprovedDate}
                            type='checkbox'
                            onChange={() => handleToggleColumn('apApprovedDate')}
                            checked={hiddenColumns.includes('apApprovedDate')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.paidDate}
                            type='checkbox'
                            onChange={() => handleToggleColumn('paidDate')}
                            checked={hiddenColumns.includes('paidDate')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={'Created By'}
                            type='checkbox'
                            onChange={() => handleToggleColumn('createdBy')}
                            checked={hiddenColumns.includes('createdBy')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={'User Status'}
                            type='checkbox'
                            onChange={() => handleToggleColumn('userStatus')}
                            checked={hiddenColumns.includes('userStatus')}
                            fieldClass='mb-4'
                          />
                          <TextField
                            rightLabel={labelKey.source}
                            type='checkbox'
                            onChange={() => handleToggleColumn('transactionSource')}
                            checked={hiddenColumns.includes('transactionSource')}
                            fieldClass='mb-4'
                          />
                        </TableSettingMenu>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading && (
                      <>
                        {data?.result?.data?.length > 0 ? (
                          <>
                            {data?.result?.data?.map((data: any, index: any) => (
                              <tr key={index}>
                                {hiddenColumns.includes('itemTransactionDate') && (
                                  <td className='ps-3'>
                                    <DateComp formattedDate={data.itemTransactionDate} />
                                  </td>
                                )}
                                {hiddenColumns.includes('reportDate') && (
                                  <td>
                                    <DateComp formattedDate={data.reportDate} />
                                  </td>
                                )}
                                {hiddenColumns.includes('syncSSToBCDateTime') && (
                                  <td>
                                    <DateComp formattedDate={data.syncSSToBCDateTime} />
                                  </td>
                                )}
                                {hiddenColumns.includes('sS_ReportNo') && (
                                  <td className='ps-5'>{data?.sS_ReportNo}</td>
                                )}
                                {hiddenColumns.includes('reportTitle') && (
                                  <td className='ps-5'>{data?.reportTitle}</td>
                                )}
                                {hiddenColumns.includes('manager') && (
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='symbol symbol-40px symbol-circle me-3'>
                                        <div className='symbol-label fs-3 bg-light-info text-info text-capitalize'>
                                          {data?.manager?.charAt(0)}
                                        </div>
                                      </div>
                                      <div className='d-flex justify-content-start flex-column'>
                                        <p className='text-capitalize mb-0'>{data?.manager}</p>
                                        <p className='text-capitalize mb-0'>{data?.managerEmail}</p>
                                      </div>
                                    </div>
                                  </td>
                                )}
                                {hiddenColumns.includes('submitted_By') && (
                                  <td>
                                    <div className='d-flex align-items-center'>
                                      <div className='symbol symbol-40px symbol-circle me-3'>
                                        <div className='symbol-label fs-3 bg-light-info text-info text-capitalize'>
                                          {data?.submitted_By?.charAt(0)}
                                        </div>
                                      </div>
                                      <div className='d-flex justify-content-start flex-column'>
                                        <p className='text-capitalize mb-0'>{data?.submitted_By}</p>
                                        <p className='text-capitalize mb-0'>
                                          {data?.userAccount?.email}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                )}
                                {hiddenColumns.includes('amount') && (
                                  <td>
                                    <CurrencyComp amount={data?.amount} />
                                  </td>
                                )}
                                {hiddenColumns.includes('categoryName') && (
                                  <td>{data?.categoryName}</td>
                                )}
                                {hiddenColumns.includes('vendorName') && <td>{data.vendorName}</td>}
                                {hiddenColumns.includes('expenseDetail') && <td>
                                  <ReactReadMoreReadLess
                                    charLimit={30}
                                    readMoreText={"Read more"}
                                    readLessText={"Read less"}
                                    readMoreClassName="readMore"
                                    readLessClassName="readLess"
                                  >
                                  {data.expenseDetail}
                                  </ReactReadMoreReadLess>
                                </td>}
                                {hiddenColumns.includes('merchantType') && (
                                  <td>{data?.merchantType}</td>
                                )}
                                {hiddenColumns.includes('paymentMethod') && (
                                  <td>{data?.paymentMethod}</td>
                                )}
                                {hiddenColumns.includes('reportStatus') && (
                                  <td>
                                    <ExpenseStatusComp
                                      expenseStatusId={data?.expenseStatusId}
                                      expenseStatusTitle={data?.reportStatus}
                                    />
                                  </td>
                                )}
                                {hiddenColumns.includes('assignedToName') && (
                                  <td>
                                    {data?.assignedToName && (
                                      <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-40px symbol-circle me-3'>
                                          <div className='symbol-label fs-3 bg-light-info text-info text-capitalize'>
                                            {data?.assignedToName?.charAt(0)}
                                          </div>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          <p className='text-capitalize mb-0'>
                                            {data?.assignedToName}
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                )}
                                {hiddenColumns.includes('receipt') && (
                                  <td>
                                    <Tooltip id='upload-reciept' place='top' />
                                    {data?.receipt === null ||
                                      data?.receipt === 'null' ||
                                      data?.receipt === 'undefined' ||
                                      data?.receipt === '' ||
                                      data?.receipt === 'Receipt is not available' ? null : (
                                      <FaEye
                                        className='ms-7'
                                        onClick={() => openPdfInBrowserOrLightbox(data?.receipt)}
                                      />
                                    )}
                                  </td>
                                )}
                                {hiddenColumns.includes('chargeDepartmentCode') && (
                                  <td>{data?.chargeDepartmentCode}</td>
                                )}
                                {hiddenColumns.includes('chargeDepartmentName') && (
                                  <td>{data?.chargeDepartmentName}</td>
                                )}
                                {hiddenColumns.includes('splitToLocationsName') && (
                                  <td>{data?.splitToLocationsName}</td>
                                )}
                                {hiddenColumns.includes('chargeLocationCode') && (
                                  <td>{data?.chargeLocationCode}</td>
                                )}
                                {hiddenColumns.includes('chargeLocationName') && (
                                  <td>{data.chargeLocationName}</td>
                                )}
                                {hiddenColumns.includes('expenseLineItemNo') && (
                                  <td>{data.expenseLineItemNo}</td>
                                )}
                                {hiddenColumns.includes('reportSubmittedDate') && (
                                  <td>
                                    <DateComp formattedDate={data.reportSubmittedDate} />
                                  </td>
                                )}
                                {hiddenColumns.includes('apApprovedDate') && (
                                  <td>
                                    <DateComp formattedDate={data.apApprovedDate} />
                                  </td>
                                )}
                                {hiddenColumns.includes('paidDate') && (
                                  <td>
                                    <DateComp formattedDate={data.paidDate} />
                                  </td>
                                )}
                                {hiddenColumns.includes('createdBy') && (
                                  <td>
                                    {data?.onBehalfOfUser && data?.onBehalfOfUser?.email && (
                                      <div className='d-flex align-items-center'>
                                        <div className='symbol symbol-40px symbol-circle me-3'>
                                          <div className='symbol-label fs-3 bg-light-info text-info text-capitalize'>
                                            {data?.onBehalfOfUser?.firstName?.charAt(0)}
                                          </div>
                                        </div>
                                        <div className='d-flex justify-content-start flex-column'>
                                          {data?.onBehalfOfUser?.firstName && (
                                            <p className='text-capitalize mb-0'>
                                              {data?.onBehalfOfUser?.firstName +
                                                ' ' +
                                                data?.onBehalfOfUser?.lastName}
                                            </p>
                                          )}
                                          {data?.onBehalfOfUser?.email && (
                                            <p className='text-capitalize mb-0'>
                                              {data?.onBehalfOfUser?.email}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                )}
                                {hiddenColumns.includes('userStatus') && (
                                  <td>
                                    <div className='d-flex gap-2'>
                                      {data?.userAccount?.userStatus === 'Active' ? (
                                        <span className='badge badge-light-success fs-7 fw-semibold'>
                                          {labelKey.active}
                                        </span>
                                      ) : (
                                        <span className='badge badge-light-danger fs-7 fw-semibold'>
                                          {labelKey.inActive}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                )}
                                {hiddenColumns.includes('transactionSource') && (
                                  <td>
                                    <Tooltip id='web-source' place='top' />
                                    <Tooltip id='mobile-source' place='top' />
                                    <Tooltip id='bank-source' place='top' />
                                    <Tooltip id='gorilla-source' place='top' />
                                    {data?.recordSourceID === constraintConfig.recordSourceId.WebApp ? (
                                      <KTSVG
                                        path='/media/icons/figmaIcons/Web.svg'
                                        className='svg-icon-1 ms-4'
                                        data-tooltip-id='web-source'
                                        data-tooltip-content='Website'
                                      />
                                    ) : data?.recordSourceID === constraintConfig.recordSourceId.Mobile ? (
                                      <KTSVG
                                        path='/media/icons/figmaIcons/Mobile.svg'
                                        className='svg-icon-1 ms-4'
                                        data-tooltip-id='mobile-source'
                                        data-tooltip-content='Mobile'
                                      />
                                    ) : data?.recordSourceID === constraintConfig.recordSourceId.BankFeed ? (
                                      <KTSVG
                                        path='/media/icons/figmaIcons/Bank.svg'
                                        className='svg-icon-1 ms-4'
                                        data-tooltip-id='bank-source'
                                        data-tooltip-content='Bank'
                                      />
                                    ) : data?.recordSourceID === constraintConfig.recordSourceId.GorillaExpense ? (
                                      <KTSVG
                                        path='/media/icons/figmaIcons/Gorilla.svg'
                                        className='svg-icon-1 ms-4'
                                        data-tooltip-id='gorilla-source'
                                        data-tooltip-content='Gorilla Expense'
                                      />
                                    ) : null}
                                  </td>
                                )}
                                <td>
                                  <Tooltip id={labelKey.itemDetail} place='top' />
                                  <div
                                    data-tooltip-id={labelKey.itemDetail}
                                    data-tooltip-content={labelKey.itemDetail}
                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                    onClick={() => {
                                      expenseItemByIdTrigger({
                                        expenseItemId: data?.expenseLineItemNo,
                                      })
                                      expenseItemModalHandler()
                                    }}
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/arrows/arr064.svg'
                                      className='svg-icon-3'
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td colSpan={20}>
                              <NoRecordFound />
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                    {isLoading && (
                      <tr>
                        <td colSpan={20} className='text-center'>
                          <LoadingComponent />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination
              totalResult={
                data?.result?.totalRecords === 0
                  ? 0
                  : (data?.result?.pageNumber - 1) * data?.result?.pageSize + 1
              }
              toResult={
                data?.result?.totalRecords === 0
                  ? 0
                  : Math.min(
                    data?.result?.pageNumber * data?.result?.pageSize,
                    data?.result?.totalRecords
                  )
              }
              ofResult={data?.result?.totalRecords}
              onChange={handlePageSizeChange}
              pageSize={pageSize}
              onPageChange={handlePageClick}
              pageCount={data?.result?.totalPages || 0}
              currentPage={page}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ExportExpenseReports